import React, { cloneElement } from 'react';
import FormItem from '../__partials/form-item';

interface IProps {
  header?: string;
  selectedValues?: any;
  children?: any;
  isDisabled?: boolean;
  status?: 'default' | 'error' | 'success';
  onClick?: any;
}

const CheckboxGroup = ({
  header,
  selectedValues,
  children,
  isDisabled,
  status,
  onClick,
}: IProps) => {
  return (
    <FormItem isDisabled={isDisabled} status={status}>
      {header && <p className="checkbox-group__header">{header}</p>}

      {children.length === undefined || children.length === 1
        ? cloneElement(children, {
            key: children.props.value,
            onClick: () => onClick(children.props.value),
            isChecked: selectedValues.includes(children.props.value),
          })
        : children.map((child: any) => {
            return cloneElement(child, {
              key: child.props.value,
              onClick: () => onClick(child.props.value),
              isChecked: selectedValues.includes(child.props.value),
            });
          })}
    </FormItem>
  );
};

export default CheckboxGroup;
